import { db } from "./config/firebase";
import { collection, addDoc } from "firebase/firestore";

export { db };

// Guardar actividad de estudiante en la nube
export async function saveActivityToCloud(activityRecord) {
  try {
    await addDoc(collection(db, "activities"), {
      ...activityRecord,
      timestamp: new Date().toISOString()
    });
    console.log("Actividad guardada exitosamente en la nube de Firebase");
  } catch (e) {
    console.error("Error al guardar en Firebase, usando respaldo local:", e);
  }
}

// Guardar nuevo registro de estudiante en la nube
export async function saveStudentToCloud(studentRecord) {
  try {
    await addDoc(collection(db, "students"), {
      ...studentRecord,
      timestamp: new Date().toISOString()
    });
    console.log("Estudiante registrado en la nube de Firebase");
  } catch (e) {
    console.error("Error al registrar estudiante en Firebase:", e);
  }
}